import { AxiosInstance } from '@service/axios-instance';

export async function createOperation(
    name: string, 
    dbHost?: string, 
    dbUser?: string, 
    dbPassword?: string,
    USER_MACHINE_ACCESS_MODE?: string,
    ACCESSED_BY?: string[]
) {
    const payload: any = { name };
    if (dbHost) payload.db_host = dbHost;
    if (dbUser) payload.db_user = dbUser;
    if (dbPassword) payload.db_password = dbPassword;
    if (USER_MACHINE_ACCESS_MODE) payload.USER_MACHINE_ACCESS_MODE = USER_MACHINE_ACCESS_MODE;
    if (ACCESSED_BY) payload.ACCESSED_BY = ACCESSED_BY;

    const res = await AxiosInstance.post('/admin/create_operation', payload, {
        withCredentials: true
    });
    return res.data;
}

export async function getOperationDefaults() {
    const res = await AxiosInstance.get('/admin/create_operation', {
        withCredentials: true
    });
    return res.data;
}
